/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ItemVariantGroupsItemVariantGroupIdDelete$Params {
  'Active-Tenant-Identifier': string;
  itemVariantGroupId: string;
}

export function itemVariantGroupsItemVariantGroupIdDelete(http: HttpClient, rootUrl: string, params: ItemVariantGroupsItemVariantGroupIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsItemVariantGroupIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantGroupId', params.itemVariantGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemVariantGroupsItemVariantGroupIdDelete.PATH = '/item-variant-groups/{itemVariantGroupId}';
